import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _FileUploadExample;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint-disable react/jsx-no-literals */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import isImage from '../common/isImage';
import FileUploadEdit from '../Edit';
import FileUploadShow from '../Show';
import FileUploadTake from '../Take';
import FileUploadResult from '../Result';
import generateStyle from '../../common/example/default';
import generateComponentTheme from '../../common/example/defaultTheme';
import { withStyleOverrides } from '@instructure/quiz-common';

/**
---
category: FileUpload
---
  FileUpload Example.

  ```jsx_example
    <SettingsSwitcher locales={LOCALES}>
      <FileUploadExample />
    </SettingsSwitcher>
  ```
**/
var FileUploadExample = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_FileUploadExample = /*#__PURE__*/function (_Component) {
  function FileUploadExample(props) {
    var _this;
    _classCallCheck(this, FileUploadExample);
    _this = _callSuper(this, FileUploadExample);
    _defineProperty(_this, "_timeouts", []);
    _defineProperty(_this, "handleChangeItemState", function (itemState) {
      var newState = {};
      if (itemState.interactionData) {
        newState.takeInteractionData = _this.transformTakeInteractionData(itemState.interactionData);
      }
      var updatedState = Object.assign({}, itemState, newState);
      _this.setState(updatedState);
    });
    _defineProperty(_this, "handleResponseUpdate", function (userResponse) {
      _this.setState({
        userResponse: {
          value: userResponse
        }
      });
    });
    _defineProperty(_this, "makeLocalLoadHandler", function (id, callback) {
      return function (event) {
        _this._timeouts = [].concat(_toConsumableArray(_this._timeouts), [setTimeout(function () {
          return callback(event.target.result);
        }, 2000 + Math.random() * 2000)]);
      };
    });
    _this.state = {};
    if (props.useDefaultData) {
      Object.assign(_this.state, {
        itemBody: 'Give two examples of tortoises',
        interactionData: {
          restrictCount: true,
          filesCount: '2'
        },
        properties: {
          restrictTypes: false,
          allowedTypes: 'media/*'
        },
        userResponse: {
          value: [{
            id: Date.now(),
            name: 'slide-3.jpg',
            url: 'http://instructure.github.io/images/slide-3.jpg',
            size: 49067
          }]
        }
      });
      _this.state.scoredData = _this.transformScoredData();
      _this.state.takeInteractionData = _this.transformTakeInteractionData(_this.state.interactionData);
    }
    return _this;
  }
  _inherits(FileUploadExample, _Component);
  return _createClass(FileUploadExample, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timeouts.forEach(clearTimeout);
    }
  }, {
    key: "transformScoredData",
    value: function transformScoredData() {
      var files = this.state.userResponse.value;
      return {
        gradeStatus: files.length > 0 ? 'graded' : 'waiting',
        value: files
      };
    }
  }, {
    key: "transformTakeInteractionData",
    value: function transformTakeInteractionData(interactionData) {
      return cloneDeep(interactionData);
    }
  }, {
    key: "renderEdit",
    value: function renderEdit() {
      return jsx("div", {
        title: "edit"
      }, jsx(Heading, {
        level: "h2"
      }, "Edit"), jsx(FileUploadEdit, {
        properties: this.state.properties,
        changeItemState: this.handleChangeItemState,
        interactionData: this.state.interactionData,
        itemBody: this.state.itemBody
      }));
    }
  }, {
    key: "renderShow",
    value: function renderShow() {
      return jsx("div", {
        title: "show"
      }, jsx(Heading, {
        level: "h2"
      }, "Show"), jsx(FileUploadShow, {
        properties: this.state.properties,
        interactionData: this.state.interactionData,
        itemBody: this.state.itemBody
      }));
    }
  }, {
    key: "renderTake",
    value: function renderTake() {
      var _this2 = this;
      return jsx("div", {
        title: "take"
      }, jsx(Heading, {
        level: "h2"
      }, "Take"), jsx(FileUploadTake, {
        properties: this.state.properties,
        interactionData: this.state.takeInteractionData,
        itemBody: this.state.itemBody,
        userResponse: this.state.userResponse,
        handleResponseUpdate: this.handleResponseUpdate,
        cancelMediaUpload: function cancelMediaUpload() {},
        mediaUpload: function mediaUpload(id, file, callback) {
          // Let's read the data and update the state
          if (isImage(file.name)) {
            var reader = new FileReader();
            reader.onload = _this2.makeLocalLoadHandler(id, callback);
            reader.readAsDataURL(file);
          }
        }
      }));
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      return jsx("div", {
        title: "result"
      }, jsx(Heading, {
        level: "h2"
      }, "Result"), jsx(FileUploadResult, {
        interactionData: this.state.takeInteractionData,
        itemBody: this.state.itemBody,
        scoredData: this.transformScoredData()
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.row
      }, jsx("div", {
        css: this.props.styles.panel
      }, this.renderEdit()), jsx("div", {
        css: this.props.styles.panel
      }, this.renderShow())), jsx("div", {
        css: this.props.styles.row
      }, jsx("div", {
        css: this.props.styles.panel
      }, this.renderTake()), jsx("div", {
        css: this.props.styles.panel
      }, this.renderResult())));
    }
  }]);
}(Component), _defineProperty(_FileUploadExample, "displayName", 'FileUploadExample'), _defineProperty(_FileUploadExample, "componentId", "Quizzes".concat(_FileUploadExample.displayName)), _defineProperty(_FileUploadExample, "propTypes", {
  useDefaultData: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_FileUploadExample, "defaultProps", {
  useDefaultData: true
}), _FileUploadExample)) || _class);
export { FileUploadExample as default };